export default "__VITE_ASSET__$y4zpuD2__"